// extracted by mini-css-extract-plugin
export default {"categoriesContainer":"Categories_categoriesContainer__oWS3M","header":"Categories_header__A1f0k","actionButtons":"Categories_actionButtons__los24"};